import { render, staticRenderFns } from "./Laboratorio.vue?vue&type=template&id=dc397732&scoped=true&"
import script from "./Laboratorio.vue?vue&type=script&lang=js&"
export * from "./Laboratorio.vue?vue&type=script&lang=js&"
import style0 from "./Laboratorio.vue?vue&type=style&index=0&id=dc397732&prod&scoped=true&lang=css&"
import style1 from "./Laboratorio.vue?vue&type=style&index=1&id=dc397732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc397732",
  null
  
)

export default component.exports